import { VideoResourcePool } from './VideoResourcePool';
import { Platform } from './Platform';
import { RenderDevice } from './RenderDevice';
import { VideoData } from './VideoData';
import { VideoDataWebGL } from './VideoDataWebGL';
import { IAssetsUrlFormatter } from '../helpers/assets-url.formatter';

export class VideoResourcePoolWebGL extends VideoResourcePool {
  private readonly _platform: Platform;
  private readonly _renderDevice: RenderDevice;

  constructor(
    platform: Platform,
    renderDevice: RenderDevice,
    assetsUrlFormatter?: IAssetsUrlFormatter
  ) {
    super('webgl', assetsUrlFormatter);
    this._platform = platform;
    this._renderDevice = renderDevice;
  }

  createData(video: HTMLVideoElement): VideoData {
    return new VideoDataWebGL(this._platform, this._renderDevice, video);
  }
}
